import { render, staticRenderFns } from "./ProtocolDeviationReport.vue?vue&type=template&id=3ff64f74&"
import script from "./ProtocolDeviationReport.vue?vue&type=script&lang=js&"
export * from "./ProtocolDeviationReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports